import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialColumnLight = {
  factory: EElement({
    id: '31db5559-ac0e-6436-ad16-bd2b7ca17ce2',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('55cb1665-6b20-764f-451f-033296b686ca')]),
      children: EList([
        EElement({
          id: '80cb845b-dd03-44b9-197d-f6358dbb0264',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'd382d83a-770f-c1aa-7ec6-5a6bbc13f905',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'd382d83a-770f-c1aa-7ec6-5a6bbc13f906',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Testimonial section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '7ea60d99-ca03-50ff-6d69-0b2fddc64116',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('1474a3b8-d073-f1b2-5a4b-4d94bd637faa'),
                  ]),
                  children: EList([
                    EElement({
                      id: '95abb3d8-f96f-7ab2-2f01-a06e3213e10e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('772d83e1-019c-2ba3-4539-814018b934ec'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'ce2631a0-cd32-94e8-5e70-063b4d35d8bb',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('b06b55a4-6e02-9580-4ada-d2c39bc0f8e9'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'ce2631a0-cd32-94e8-5e70-063b4d35d8bc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '28ad03e4-71e5-2b5d-e496-dbdee382f80e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('c84bfa02-6049-624f-7391-997eaa281c9a'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '6c5003d9-3cf3-e8c9-7e6c-7405d2963f38',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730f859765baa36e654c12"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '163746dd-f17d-8612-84f5-86b5fbb30f1a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '163746dd-f17d-8612-84f5-86b5fbb30f1b',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          styleBlockIds: EList([
                                            EText(
                                              'fb7f4207-fdf3-ac41-ce24-052261a1f39c'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '163746dd-f17d-8612-84f5-86b5fbb30f1c',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '163746dd-f17d-8612-84f5-86b5fbb30f1d',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: '163746dd-f17d-8612-84f5-86b5fbb30f1e',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('VP of Company'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '265c5721-dab3-8867-eaf3-ee3a2a87a7d8',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('772d83e1-019c-2ba3-4539-814018b934ec'),
                        ]),
                        children: EList([
                          EElement({
                            id: '265c5721-dab3-8867-eaf3-ee3a2a87a7d9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('b06b55a4-6e02-9580-4ada-d2c39bc0f8e9'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '265c5721-dab3-8867-eaf3-ee3a2a87a7da',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '265c5721-dab3-8867-eaf3-ee3a2a87a7db',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('c84bfa02-6049-624f-7391-997eaa281c9a'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '265c5721-dab3-8867-eaf3-ee3a2a87a7dc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730f859765baa36e654c12"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '265c5721-dab3-8867-eaf3-ee3a2a87a7dd',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '265c5721-dab3-8867-eaf3-ee3a2a87a7de',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          styleBlockIds: EList([
                                            EText(
                                              'fb7f4207-fdf3-ac41-ce24-052261a1f39c'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '265c5721-dab3-8867-eaf3-ee3a2a87a7df',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '265c5721-dab3-8867-eaf3-ee3a2a87a7e0',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: '265c5721-dab3-8867-eaf3-ee3a2a87a7e1',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('VP of Company'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7dc',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('772d83e1-019c-2ba3-4539-814018b934ec'),
                        ]),
                        children: EList([
                          EElement({
                            id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7dd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('b06b55a4-6e02-9580-4ada-d2c39bc0f8e9'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7de',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7df',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('c84bfa02-6049-624f-7391-997eaa281c9a'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e0',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730f859765baa36e654c12"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e2',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          styleBlockIds: EList([
                                            EText(
                                              'fb7f4207-fdf3-ac41-ce24-052261a1f39c'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: '6e09b74b-3c32-26e3-c754-8a1d98b7c7e5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('VP of Company'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '55cb1665-6b20-764f-451f-033296b686ca',
      type: 'class',
      name: 'Testimonial Column Light',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: '1474a3b8-d073-f1b2-5a4b-4d94bd637faa',
      type: 'class',
      name: 'Testimonial Grid Two',
      comb: '',
      styleLess:
        'display: grid; margin-top: 50px; grid-auto-columns: 1fr; grid-column-gap: 40px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-column-gap: 30px;'},
        small: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '772d83e1-019c-2ba3-4539-814018b934ec',
      type: 'class',
      name: 'Testimonial Card Two',
      comb: '',
      styleLess:
        'display: flex; padding-top: 32px; padding-right: 16px; padding-bottom: 16px; padding-left: 16px; flex-direction: column; border-top-style: solid; border-top-width: 1px; border-top-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); border-right-style: solid; border-right-width: 1px; border-right-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); border-left-style: solid; border-left-width: 1px; border-left-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: 'b06b55a4-6e02-9580-4ada-d2c39bc0f8e9',
      type: 'class',
      name: 'Testimonial Text Two',
      comb: '',
      styleLess: 'margin-bottom: 52px;',
      children: [],
      variants: {},
    },
    {
      _id: 'c84bfa02-6049-624f-7391-997eaa281c9a',
      type: 'class',
      name: 'Testimonial Info Three',
      comb: '',
      styleLess:
        'display: flex; padding-top: 24px; padding-right: 16px; padding-bottom: 24px; padding-left: 16px; align-items: center; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        medium: {styleLess: 'flex-direction: column;'},
        small: {styleLess: 'flex-direction: row;'},
      },
    },
    {
      _id: 'eee554db-e006-8dc8-ae3d-0f25db8d5e13',
      type: 'class',
      name: 'Testimonial Image',
      comb: '',
      styleLess:
        'width: 60px; height: 60px; margin-right: 16px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: ['ef5c9902-3a40-6a1b-9c7a-521d48c5e000'],
      variants: {},
    },
    {
      _id: 'fb7f4207-fdf3-ac41-ce24-052261a1f39c',
      type: 'class',
      name: 'Testimonial Main Heading',
      comb: '',
      styleLess: 'margin-bottom: 2px; font-weight: 600;',
      children: [],
      variants: {},
    },
  ],
} as const;
